<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DASHBOARD MOD
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglData"
                    class="w-full grow mr-5"
                    id="tgl"
                    label="PILIH TANGGAL"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <button
                    @click.prevent="exportExcelAll()"
                    class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                >
                    EXPORT EXCEL
                </button>
                <button
                    @click.prevent="getModDashboard()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center self-end w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="border-2 border-black rounded-md p-5 mb-2">
                    <div
                        class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3"
                    >
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold bg-amber-100">
                                <td class="py-2 px-3 text-center text-sm" colspan="2">REKAP PASIEN POLIKLINIK</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Antrian:  {{ dashboardModData.rekapPasienPoli.totalAntrian }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Register: {{ dashboardModData.rekapPasienPoli.totalRegister }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Terlayani: {{ dashboardModData.rekapPasienPoli.totalTerlayani }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div
                        class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8"
                    >
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        No
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kode Poli
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Nama Poli
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        BPJS
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Umum
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Lainnya
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Total Antrian
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terlayani
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Jam Mulai
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Jam Selesai
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="rekapPasienPoliData in dashboardModData.rekapPasienPoli.data"
                                    class="hover:bg-gray-100"
                                >
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.no }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.kodePoli }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.namaPoli }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.bpjs }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.umum }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.lainnya }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.totalAntrian }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.terlayani }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.jamMulai }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienPoliData.jamSelesai }}
                                    </td>
                                </tr>
                                <tr
                                    class="bg-white hover:bg-gray-100 focus-within:bg-gray-100"
                                    v-if="dashboardModData.rekapPasienPoli.data.length === 0"
                                >
                                    <td
                                        class="border-r border-t text-sm select-none cursor-pointer pl-2"
                                        colspan="15"
                                    >
                                        Belum ada data rekap pasien poliklinik
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="border-2 border-black rounded-md p-5 mb-2">
                    <div
                        class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3"
                    >
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold bg-amber-100">
                                <td class="py-2 px-3 text-center text-sm" colspan="5">REKAP PASIEN IGD</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">

                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    BPJS
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    Umum
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    Lainnya
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    Total
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Register:
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.register.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.register.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.register.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.register.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Aktif:
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.aktif.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.aktif.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.aktif.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.aktif.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Terlayani (RI/RJ):
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.terlayani_ri_rj.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.terlayani_ri_rj.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.terlayani_ri_rj.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.terlayani_ri_rj.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Rawat Inap:
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_inap.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_inap.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_inap.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_inap.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Rawat Jalan
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_jalan.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_jalan.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_jalan.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.rawat_jalan.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    Batal
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.batal.bpjs }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.batal.umum }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.batal.lainnya }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                >
                                    {{ dashboardModData.rekapPasienIgd.batal.total }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="border-2 border-black rounded-md p-5 mb-2">
                    <div
                        class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3"
                    >
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold bg-amber-100">
                                <td class="py-2 px-3 text-center text-sm" colspan="2">REKAP PASIEN RAWAT INAP</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Pasien Rawat Inap:  {{ dashboardModData.rekapPasienRanap.total }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Jaminan BPJS: {{ dashboardModData.rekapPasienRanap.bpjs }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Jaminan Umum: {{ dashboardModData.rekapPasienRanap.umum }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Jaminan Lainnya: {{ dashboardModData.rekapPasienRanap.lainnya }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div
                        class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8"
                    >
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        Ruang
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        BPJS
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Umum
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Lainnya
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Reg Masuk
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Reg Keluar 
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Bayi
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="rekapPasienRanapData in dashboardModData.rekapPasienRanap.data"
                                    class="hover:bg-gray-100"
                                >
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.ruang }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.terpakai }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ rekapPasienRanapData.kosong }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.bpjs }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.umum }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.lainnya }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.regMasuk }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.regKeluar }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapData.bayi }}
                                    </td>
                                </tr>
                                <tr
                                    class="bg-white hover:bg-gray-100 focus-within:bg-gray-100"
                                >
                                    <td
                                        v-if="dashboardModData.rekapPasienRanap.data.length === 0"
                                        class="border-r border-t text-sm select-none cursor-pointer pl-2"
                                        colspan="15"
                                    >
                                        Belum ada data rekap pasien rawat inap
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="border-2 border-black rounded-md p-5 mb-2">
                    <button
                        @click.prevent="exportExcel()"
                        class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                    >
                        EXPORT EXCEL
                    </button>
                    <div
                        class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3"
                    >
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold bg-amber-100">
                                <td class="py-2 px-3 text-center text-sm" colspan="3">REKAP PASIEN RAWAT INAP PER KELAS PERAWATAN</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Pasien Rawat Inap:  {{ dashboardModData.rekapPasienRanapPerKelas.total }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    Total Bed Kosong:  {{ dashboardModData.rekapPasienRanapPerKelas.totalBedKosong }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K1 Terpakai: {{ dashboardModData.rekapPasienRanapPerKelas.bedK1.pakai }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K1 Kosong: {{ dashboardModData.rekapPasienRanapPerKelas.bedK1.kosong }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K2 Terpakai: {{ dashboardModData.rekapPasienRanapPerKelas.bedK2.pakai }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K2 Kosong: {{ dashboardModData.rekapPasienRanapPerKelas.bedK2.kosong }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K3 Terpakai: {{ dashboardModData.rekapPasienRanapPerKelas.bedK3.pakai }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED K3 Kosong: {{ dashboardModData.rekapPasienRanapPerKelas.bedK3.kosong }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED ICU Terpakai: {{ dashboardModData.rekapPasienRanapPerKelas.bedICU.pakai }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED ICU Kosong: {{ dashboardModData.rekapPasienRanapPerKelas.bedICU.kosong }}
                                </td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED VIP Terpakai: {{ dashboardModData.rekapPasienRanapPerKelas.bedVIP.pakai }}
                                </td>
                                <td
                                    class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    colspan="2"
                                >
                                    BED VIP Kosong: {{ dashboardModData.rekapPasienRanapPerKelas.bedVIP.kosong }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div
                        class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8"
                    >
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        Ruang
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai K3
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong K3
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai K2
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong K2
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai K1
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong K1
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai ICU 
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong ICU
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Terpakai VIP
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Kosong VIP
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="rekapPasienRanapDataPerKelas in dashboardModData.rekapPasienRanapPerKelas.data"
                                    class="hover:bg-gray-100"
                                >
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.ruang }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.pakaiK3 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ rekapPasienRanapDataPerKelas.kosongK3 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.pakaiK2 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.kosongK2 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.pakaiK1 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.kosongK1 }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.pakaiICU }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.kosongICU }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.pakaiVIP }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                        {{ rekapPasienRanapDataPerKelas.kosongVIP }}
                                    </td>
                                </tr>
                                <tr
                                    class="bg-white hover:bg-gray-100 focus-within:bg-gray-100"
                                >
                                    <td
                                        v-if="dashboardModData.rekapPasienRanapPerKelas.data.length === 0"
                                        class="border-r border-t text-sm select-none cursor-pointer pl-2"
                                        colspan="11"
                                    >
                                        Belum ada data rekap pasien rawat inap per kelas
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput,
    },
    data() {
        return {
            tglData: this.tgl,
            dashboardModData: this.dashboardMod,
            // timerCount: 600,
        };
    },
    watch: {
        // timerCount: {
        //     handler(value) {
        //         if (value > 0) {
        //             setTimeout(() => {
        //                 this.timerCount--;
        //             }, 1000);
        //         } else {
        //             this.getPasienIgd();
        //         }
        //     },
        //     immediate: true,
        // },
    },
    props: {
        tgl: String,
        dashboardMod: Object,
    },
    methods: {
        getModDashboard() {
            this.$inertia.get(
                "/admin/mod_dashboard/ajax",
                {
                    tgl: this.tglData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        // this.timerCount = 600;
                        this.dashboardModData = page.props.additional.dashboardMod;
                    },
                }
            );
        },
        exportExcelAll(){
            location.href = '/admin/mod_dashboard/export/excel?tgl='+this.tglData;
        },
        exportExcel(){
            location.href = '/admin/rekap_pasien_ranap_per_kelas/export/excel?tgl='+this.tglData;
        }
    },
    layout: LayoutAdminBig,
};
</script>
